module.exports = __webpack_public_path__ + "static/marble-5ed7f32c0374544666a476afb88e20eb.jpg";